export const environment = {
  b2b_access_token: 'test_jwt',
  b2b_refresh_token: 'test_refresh_token',
  b2c_refresh_token: 'refreshToken',
  b2c_access_token: 'token',
  buyer_access_token: 'buyer_token',
  b2c_profile: 'profile',
  b2c_language: 'PowerSiteLanguage',
  currency: 'PowerSiteCurrency',
  ojwt: 'test_ojwt',
  orefresh_token: 'test_orefresh_token',
  url_token: 'test_url_token',
  token_referrer: 'test_token_referrer',
  roles: 'test_roles',
  appInsightsKey: 'bbdccdfa-52d8-42dc-85df-46c7a839785a',
  dismiss_app_banner: 'PowerSiteDismissAppBanner',
  b2b_clientId: '4365c7b8ed384bc9934932866df303e6',
  b2c_clientId: 'd5293879570c4e43b5ee79f159e5457b',
  applink: 'https://applink-test.properstar.com/link',
  dashboardLink: 'https://dashboard-test.properstar.com/',
  properstarLink: 'https://release.properstar.com',
  acsChatUrl:
    'https://cs-communications-test-acs.europe.communication.azure.com',
}
